import Head from "next/head";
import base64 from "base-64";
function stripHtml(html) {
  if (!html) return "";

  return html
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/<\/?[^>]+(>|$)/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}

export default function JobSchema({ data, title, description, image }) {
  let schemaData = {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    title: data?.JobTitle,
    description: data?.JobDescription
      ? stripHtml(base64.decode(data?.JobDescription))
      : "",
    hiringOrganization: {
      "@type": "Organization",
      name: data?.CompanyInfo?.CompanyName,
      sameAs: "",
      logo: data?.CompanyInfo?.CompanyLogo,
    },
    industry: data?.Industry,
    employmentType: data?.JobType,
    workHours: "",
    datePosted: data?.JobPostAddedOn,
    validThrough: "",
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: data?.CompanyInfo?.GeoLocation?.Address,
        addressLocality: data?.City,
        postalCode: "",
        addressCountry: data?.Country,
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "",
      value: {
        "@type": "QuantitativeValue",
        minValue: "",
        maxValue: "",
        unitText: "",
      },
    },
    responsibilities: "",
    skills: "",
    qualifications: data?.JobDescription
      ? stripHtml(base64.decode(data?.JobDescription))
      : "",
    educationRequirements: "",
    experienceRequirements: data?.ExperienceLevel,
  };
  return (
    <>
      <Head>
        <meta
          property="og:title"
          content={title ? title : "HireSide by WebHR"}
        ></meta>
        <meta
          property="og:description"
          content={description ? description : "HireSide by WebHR"}
        ></meta>
        <meta
          property="og:image"
          content={image ? image : "https://hireside.com/url_logo.png"}
        ></meta>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Head>
    </>
  );
}
